import { create } from "zustand";
import { NAV_WIDTH } from "../../constants";

interface State {
  containerWidth: number;
  blurWidth: number;
  navWidth: number;
}

interface Action {
  setContainerWidth: (v: number) => void;
  setNavWidth: (v: number) => void;
  openNav: () => void;
  closeNav: () => void;
  closeAndHideNav: () => void;
}

const useNavStore = create<State & Action>((set) => ({
  containerWidth: 0,
  blurWidth: 0,
  navWidth: 0,
  setContainerWidth: (containerWidth: number): void => {
    set({ containerWidth });
  },
  setNavWidth: (navWidth: number): void => {
    set({ navWidth });
  },
  openNav: (): void => {
    set({
      navWidth: NAV_WIDTH,
      containerWidth: window.innerWidth,
      blurWidth: window.innerWidth,
    });
  },
  closeNav: (): void => {
    set({
      navWidth: 96,
      containerWidth: 96,
      blurWidth: 0,
    });
  },
  closeAndHideNav: (): void => {
    set({
      navWidth: 0,
      containerWidth: 0,
      blurWidth: 0,
    });
  },
}));

export default useNavStore;
